export default "__VITE_ASSET__B4E7Aql6__"